import React, { useRef } from 'react';
import { FormProvider } from 'react-hook-form';
import RightModalLayout from '../../../layouts/Modal/RightModalLayout';
import { useWebhookForm } from '../hooks/useWebhookForm';
import WebhookFormView from './WebhookFormView';
import WebhookJsonEditor from './WebhookJsonEditor';
import WebhookHeaderEditor from './WebhookHeaderEditor';

/**
 * WebhookModal - Modal component for creating/editing a webhook.
 */
const WebhookModal = (props) => {
  const { webhookToEdit, onSuccess } = props;
  const {
    methods,
    onSubmit,
    eventTypeOptions,
    availableEvents,
    handleEventToggle,
    view,
    showVariables,
    variableOptions,
    toggleVariables,
    filterVariables,
    handleEditJson,
    handleSaveJson,
    handleCancelJson,
    handleRemoveJson,
    handleEditHeaders,
    handleSaveHeaders,
    handleCancelHeaders,
    handleRemoveHeaders,
    availableColumns,
    headerFields,
    appendHeader,
    removeHeader,
    t,
    eventType
  } = useWebhookForm({ webhookToEdit, onSuccess });

  const isFormView = view === 'form';
  const isJsonView = view === 'jsonEditor';
  const isHeaderView = view === 'headerEditor';
  const jsonBody = methods.watch('jsonBody');
  const headers = methods.watch('headers');

  // Refs to trigger property lists manually
  const jsonEditorRef = useRef(null);
  const headerValueRefs = useRef({});

  return (
    <FormProvider {...methods}>
      <RightModalLayout
        title={isFormView ? (webhookToEdit ? t('modal_title_edit') : t('modal_title_create')) : (isJsonView ? t('json_editor_title') : t('webhook_header_title'))}
        submitAction={isFormView ? onSubmit : (isJsonView ? handleSaveJson : handleSaveHeaders)}
        submitLabel={isFormView ? t('save_webhook') : (isJsonView ? t('save_json_button') : t('save_button'))}
        cancelLabel={isFormView ? null : t('cancel_button')}
        cancelAction={isFormView ? null : (isJsonView ? handleCancelJson : handleCancelHeaders)}
        showBackButton={!isFormView}
        closeAction={isFormView ? null : (isJsonView ? handleCancelJson : handleCancelHeaders)}
      >
        {isFormView && (
          <WebhookFormView
            methods={methods}
            t={t}
            eventType={eventType}
            eventTypeOptions={eventTypeOptions}
            availableEvents={availableEvents}
            handleEventToggle={handleEventToggle}
            headers={headers}
            handleEditHeaders={handleEditHeaders}
            handleRemoveHeaders={handleRemoveHeaders}
            jsonBody={jsonBody}
            handleEditJson={handleEditJson}
            handleRemoveJson={handleRemoveJson}
          />
        )}

        {isJsonView && (
          <WebhookJsonEditor
            ref={jsonEditorRef}
            t={t}
            availableColumns={availableColumns}
            showVariables={showVariables}
            toggleVariables={toggleVariables}
            variableOptions={variableOptions}
            filterVariables={filterVariables}
          />
        )}

        {isHeaderView && (
          <WebhookHeaderEditor
            ref={headerValueRefs}
            t={t}
            headerFields={headerFields}
            removeHeader={removeHeader}
            availableColumns={availableColumns}
            appendHeader={appendHeader}
          />
        )}
      </RightModalLayout>
    </FormProvider>
  );
};

export default WebhookModal;
